import React, { useState } from "react";
import "./PlatformCard.scss";
import {
  CodeRoundedIcon,
  PlatformIcon,
  TrashcanIcon,
} from "@pl-flight-recorder/web/components/icons";
import { PulseMenu } from "@pulselabs-ai/shared-fe-ui";
import { StatusDotIcon } from "@pl-flight-recorder/web/components/icons";
import { SDKCodeResponse } from "@pl-flight-recorder/web/services/MfaSDKCodeService";

// Updated PlatformCard component
interface PlatformCardProps {
  sdkProject: SDKCodeResponse;
  onDelete: (sdkProject: SDKCodeResponse) => void;
  onViewCode: (sdkProject: SDKCodeResponse) => void;
  platform: string;
  status: string;
  installationCode: string;
}

const PlatformCard: React.FC<PlatformCardProps> = ({
  sdkProject,
  onDelete,
  onViewCode,
  platform,
  status,
  installationCode,
}) => {
  const handleViewCode = () => {
    console.log("view-code", sdkProject);
    onViewCode(sdkProject);
    handleMenuClose();
  };

  const handleDelete = () => {
    onDelete(sdkProject);
    handleMenuClose();
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const menuOptions = [
    {
      label: "View Code",
      value: "view-code",
      icon: <CodeRoundedIcon />,
    },
    {
      label: "Delete",
      value: "delete",
      icon: <TrashcanIcon />,
    },
  ];

  return (
    <div className="platform-card">
      <div className="platform-info">
        <div className="status-indicator">
          <StatusDotIcon status={status} />
        </div>
        <div className="sub-headline-xs color-text-primary">{platform}</div>
      </div>

      <div className="installation-info">
        <div className="sdk-info">
          <span className="icon">
            <PlatformIcon />
          </span>
          <div className="label-s --foundation-neutral-750">
            {installationCode}
          </div>
        </div>
        <PulseMenu
          options={menuOptions}
          onClose={handleMenuClose}
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onOptionSelect={(value: string) => {
            if (value === "view-code") handleViewCode();
            if (value === "delete") handleDelete();
          }}
        />
      </div>
    </div>
  );
};

export default PlatformCard;
